import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";

import { getTipoMantenimiento } from "../../../../API/Mantenimiento/MantenimientoRequest";
import TipoMantenimientoCRUD from "./TipoMantenimientoCRUD";


const TipoMantenimientoScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [tipoMantenimiento, setTipoMantenimiento] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const tipoT = await getTipoMantenimiento()
    setTipoMantenimiento(tipoT);
    setLoading(false);
  };



  const columns = [
    {
      field: "IdTipoMantenimiento",
      header: "ID",
      headerEn:"ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "TipoMantenimiento",
      header: "Tipo Mantenimiento",
      headerEn:"Maintenance Type",
      className: "Xlarge",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn:"Description",
      className: "Xlarge",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado", 
      filter:false,    
      body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
    },
    {
      field: "IdTipoMantenimiento",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: tipoMantenimiento,
    loading: loading,
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "tipoMantenimiento", config.language));
    getInfo();
  }, []);

  return (
    <div
    className=" p-fluid px-4"
    style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "tipoMantenimiento", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <TipoMantenimientoCRUD
          toastRef={toast}
          showDialog={showDialog}
          selected={selected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default TipoMantenimientoScreen;
